'use client';

import { PageHeader } from '@/components/layout/page-header/page-header';
import { PageWrapper } from '@/components/layout/page-wrapper/page-wrapper';
import { Link } from '@/shared/navigation';
import { ROUTES } from '@/shared/routes/routes';
import { Button, Card } from '@nextui-org/react';

const consent = {
  title: 'Согласие на обработку персональных данных',
  sections: [
    {
      title: '1. Общие положения',
      content: [
        'Настоящее Согласие на обработку персональных данных (далее — Согласие) дается Пользователем сайта https://enjoy-toys.store (далее — Сайт) свободно, своей волей и в своем интересе в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных».',
        'Оператор персональных данных: Камбур Марьяна Константиновна, ИНН 7710140679, самозанятая (далее — Оператор).',
        'Согласие дается путем проставления отметки в поле «Я даю согласие на обработку персональных данных» в формах Сайта. Проставление такой отметки означает, что Пользователь ознакомился с настоящим Согласием и Политикой конфиденциальности и принимает их условия.',
        'Согласие распространяется на данные, которые Пользователь сообщает при регистрации, оформлении и оплате заказа, публикации отзыва, обращении в поддержку, а также на данные, автоматически получаемые Сайтом в порядке, описанном в Политике использования cookies.',
      ],
    },
    {
      title: '2. Перечень персональных данных',
      content: [
        'Адрес электронной почты — указывается при регистрации, при оформлении заказа без авторизации, а также для получения промокода за отзыв.',
        'Имя пользователя (логин) и имя, указанное в отзыве.',
        'Текст отзыва, оценка и фотографии, добровольно приложенные Пользователем к отзыву.',
        'Текст обращения в службу поддержки.',
        'Сведения о заказах, приобретенных мастер-классах и использованных промокодах.',
        'Технические данные: IP-адрес, сведения о браузере и устройстве, данные файлов cookie и систем веб-аналитики.',
        'Оператор не запрашивает и не обрабатывает специальные категории персональных данных, а также биометрические персональные данные.',
      ],
    },
    {
      title: '3. Цели обработки персональных данных',
      content: [
        'Регистрация и идентификация Пользователя на Сайте, предоставление доступа к личному кабинету и приобретенным материалам.',
        'Заключение и исполнение договора купли-продажи (публичной оферты): обработка заказа, проведение оплаты, направление приобретенных мастер-классов на указанный адрес электронной почты.',
        'Публикация отзывов на Сайте после модерации и направление промокода за оставленный отзыв.',
        'Обработка обращений Пользователя и информирование о статусе заказа.',
        'Направление информационных и рекламных сообщений — только при наличии отдельного согласия Пользователя, от которого можно отказаться в любой момент.',
        'Анализ качества работы Сайта и улучшение сервиса с использованием обезличенных статистических данных.',
      ],
    },
    {
      title: '4. Перечень действий с персональными данными',
      content: [
        'Пользователь дает согласие на совершение следующих действий: сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (предоставление, доступ), обезличивание, блокирование, удаление и уничтожение персональных данных.',
        'Обработка осуществляется как автоматизированным способом, так и без использования средств автоматизации, а также смешанным способом.',
        'Оператор вправе поручить обработку персональных данных третьим лицам в объеме, необходимом для оказания услуг: платежным сервисам — для проведения оплаты, сервисам почтовых рассылок — для доставки писем, хостинг-провайдерам — для размещения Сайта, сервисам веб-аналитики — для сбора обезличенной статистики. При таком поручении Оператор обязывает указанных лиц соблюдать конфиденциальность.',
        'Оператор не осуществляет трансграничную передачу персональных данных и не принимает на основании исключительно автоматизированной обработки решений, порождающих юридические последствия для Пользователя.',
      ],
    },
    {
      title: '5. Срок действия и порядок отзыва Согласия',
      content: [
        'Согласие действует с момента его предоставления и до достижения целей обработки либо до момента его отзыва Пользователем.',
        'Пользователь вправе отозвать Согласие в любой момент, направив уведомление на адрес электронной почты Оператора petromars444@gmail.com с пометкой «Отзыв согласия на обработку персональных данных».',
        'После отзыва Согласия Оператор прекращает обработку персональных данных и уничтожает их в срок, не превышающий 30 дней, за исключением данных, которые Оператор обязан хранить в силу закона либо которые необходимы для исполнения заключенного договора и подтверждения совершенных операций.',
        'Отзыв Согласия может повлечь невозможность дальнейшего использования личного кабинета и доступа к ранее приобретенным материалам.',
      ],
    },
    {
      title: '6. Права Пользователя',
      content: [
        'Пользователь вправе получать информацию, касающуюся обработки его персональных данных, требовать их уточнения, блокирования или уничтожения, если они являются неполными, устаревшими, неточными или незаконно полученными.',
        'Пользователь вправе обжаловать действия или бездействие Оператора в Роскомнадзоре или в судебном порядке.',
        'Пользователь подтверждает, что указанные им персональные данные являются достоверными и принадлежат ему, а в случае указания данных третьего лица — что он обладает полномочиями на их предоставление.',
        'Пользователь подтверждает, что он достиг возраста 18 лет либо действует с согласия своего законного представителя.',
      ],
    },
    {
      title: '7. Заключительные положения',
      content: [
        'Порядок обработки и защиты персональных данных подробно описан в Политике конфиденциальности, размещенной по адресу https://enjoy-toys.store/privacy.',
        'Условия приобретения мастер-классов определены Публичной офертой, размещенной по адресу https://enjoy-toys.store/offer.',
        'По всем вопросам, связанным с обработкой персональных данных, можно обратиться к Оператору по адресу электронной почты petromars444@gmail.com.',
        'Актуальная версия настоящего Согласия в свободном доступе размещена по адресу https://enjoy-toys.store/consent.',
      ],
    },
  ],
};

export default function Page() {
  return (
    <PageWrapper>
      <div className=" gap-10 pb-10  flex flex-col">
        <div className="hidden md:block">
          <PageHeader
            title="Согласие на обработку персональных данных"
            subTitle="Условия, на которых мы обрабатываем ваши данные"
          />
        </div>

        <Card className="p-4">
          <h1 className="text-2xl font-bold text-center mb-6">
            {consent.title}
          </h1>
          <div className="space-y-6">
            {consent.sections.map((section, index) => (
              <div key={index} className="border-b pb-4">
                <h2 className="text-2xl font-semibold text-gray-700 mb-2">
                  {section.title}
                </h2>
                <ul className="list-disc pl-5 space-y-2">
                  {section.content.map((item, idx) => (
                    <li key={idx} className="text-gray-600">
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </Card>

        <div className="w-full flex flex-wrap gap-2 justify-center">
          <Link href={ROUTES.privacy}>
            <Button variant="flat">Политика конфиденциальности</Button>
          </Link>
          <Link href={ROUTES.offer}>
            <Button variant="flat">Публичная оферта</Button>
          </Link>
          <Link href={ROUTES.home}>
            <Button color="primary">На главную</Button>
          </Link>
        </div>
      </div>
    </PageWrapper>
  );
}
